const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:4101';

export function getToken() { return localStorage.getItem('lifeLearningAdminToken'); }
export function setToken(token) { token ? localStorage.setItem('lifeLearningAdminToken', token) : localStorage.removeItem('lifeLearningAdminToken'); }

export function mediaSrc(url) {
  if (!url) return '';
  if (/^https?:\/\//i.test(url)) return url;
  return `${apiUrl}${url.startsWith('/') ? url : `/${url}`}`;
}

export async function request(path, options = {}) {
  const headers = { ...(options.body instanceof FormData ? {} : { 'Content-Type': 'application/json' }), ...(options.headers || {}) };
  const token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  const response = await fetch(`${apiUrl}${path}`, { ...options, headers });
  if (response.status === 204) return null;
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(payload.error?.message || `Ошибка ${response.status}`);
  return payload.data;
}

export async function upload(file, kind) {
  const body = new FormData(); body.append('file', file); if (kind) body.append('kind', kind);
  return request('/api/v1/admin/media', { method: 'POST', body });
}

export async function deleteMedia(mediaId) {
  return request(`/api/v1/admin/media/${mediaId}`, { method: 'DELETE' });
}

export async function deleteCharacterAsset(assetId) {
  return request(`/api/v1/admin/character-assets/${assetId}`, { method: 'DELETE' });
}

export async function uploadCharacterAsset(characterId, file, fields = {}) {
  const body = new FormData();
  body.append('file', file);
  if (fields.type) body.append('type', fields.type);
  if (fields.label) body.append('label', fields.label);
  if (fields.emotion) body.append('emotion', fields.emotion);
  return request(`/api/v1/admin/characters/${characterId}/assets/upload`, { method: 'POST', body });
}
